// extracted by mini-css-extract-plugin
export default {"wrapper":"App_wrapper__nlASx","App":"App_App__2+VHF","App__header_wrapper":"App_App__header_wrapper__qmfiI","App__section_btn":"App_App__section_btn__0s901"};